import styled from '@emotion/styled';
import { borderRadii } from '__app/spacing';
import { KizenTypography } from '__app/typography';
import Button from '__components/Button';
import { BasicRichTextEditor } from '__components/WYSIWYG';

export const StyledNotice = styled(KizenTypography)`
  padding: 10px;
  background-color: var(--color-feedback-info-bg);
  margin-bottom: 15px;
  & > span {
    font-size: inherit;
  }
`;

export const StyledParameterWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const StyledParameterCard = styled.div<{ hasError: boolean }>`
  width: 100%;
  display: flex;
  padding: 15px;
  gap: 20px;
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? 'var(--color-button-warning-default)'
        : 'var(--color-border-medium)'};
  border-radius: ${borderRadii.small};
`;

export const StyledParameterList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  &:not(:empty) {
    margin-bottom: 17px;
  }
`;

export const StyledAddParameterButton = styled(Button)`
  margin: 0;
  padding: 0;
  height: fit-content;
  width: fit-content;
`;

export const StyledNameWrapper = styled.div`
  width: 260px;
  flex-shrink: 0;
`;

export const StyledValueWrapper = styled.div`
  width: 100%;
`;

export const StyledLink = styled(KizenTypography)`
  font-size: 14px;
`;

const SCRIPT_EXAMPLE_OFFSET = -9;

export const StyledScriptExample = styled(BasicRichTextEditor)`
  display: inline-block;
  font-size: 14px;

  & > div {
    border: none;
    margin-top: ${SCRIPT_EXAMPLE_OFFSET}px;
    position: relative;
    bottom: ${SCRIPT_EXAMPLE_OFFSET}px;
    background-color: transparent;
    & > div {
      background-color: transparent;
    }
  }
  && .ProseMirror {
    border: none;
    padding: 0;
  }
  pre {
    margin: 0;
  }
`;
